export const selectPracticeCCNoGroup = state =>
  state?.practices?.costCentersNoGroup;
export const selectPracticeCCNoBu = state => state?.practices?.costCentersNoBu;
